import React, { useState } from "react";
import { Box, Container, Flex, Icon, Image } from "@chakra-ui/react";
import { BsList, BsX } from "react-icons/bs";
import HeaderMobileCourtine from "./HeaderMobileCourtine";
import { createPortal } from "react-dom";
import SmoothScrolling from "../../smoothScroll";
import DesktopLink from "./DesktopLink";

const Header = () => {
  const [menuMobile, setMenuMobile] = useState(false);

  const disableBodyScroll = () => (document.body.style.overflow = "hidden");

  const enableBodyScroll = () => {
    document.body.style.overflow = "auto";
  };

  const closeMenuMobile = () => {
    enableBodyScroll();
    setMenuMobile(false);
  };

  const openMenuMobile = () => {
    if (!menuMobile) {
      disableBodyScroll();
      setMenuMobile(true);
    }
  };

  const onCloseClick = () => {
    closeMenuMobile();
  };

  const showMenuMobile = () => {
    if (!menuMobile) return null;
    let modalWrapper = document.querySelector(".menu-mobile");

    if (!modalWrapper) {
      modalWrapper = document.createElement("div");
      modalWrapper.className = "menu-mobile";
    }

    document.body.appendChild(modalWrapper);
    return createPortal(
      <HeaderMobileCourtine closeMobile={onCloseClick} />,
      modalWrapper
    );
  };

  const scrollTo = (id) => {
    SmoothScrolling.scrollTo(id);
  };

  return (
    <Box
      bg="#000000"
      py={4}
      zIndex="999"
      pos="fixed"
      top="0"
      left="0"
      w="100%"
      h="62px"
    >
      <Container maxW="container.xl">
        <Flex
          pos="relative"
          w="100%"
          flexDirection="row"
          alignItems="center"
          justifyContent="center"
          d={["flex", null, null, null, "none"]}
        >
          <Image
            alt="Logo"
            src="/assets/images/logo_white.png"
            w="60%"
            maxW="300px"
          />
          {menuMobile ? (
            <Icon
              onClick={onCloseClick}
              cursor="pointer"
              color="#fff"
              fontSize="35px"
              as={BsX}
              pos="absolute"
              right="0px"
            />
          ) : (
            <Icon
              onClick={openMenuMobile}
              cursor="pointer"
              as={BsList}
              color="#fff"
              fontSize="30px"
              pos="absolute"
              right="0px"
            />
          )}
        </Flex>
        <Flex
          w="100%"
          flexDirection="row"
          alignItems="center"
          justifyContent="space-between"
          d={["none", null, null, null, "flex"]}
        >
          <Image alt="Logo" src="/assets/images/logo_white.png" w="20%" />
          <Flex>
            <DesktopLink onClick={() => scrollTo("votacao")}>
              Resultado
            </DesktopLink>
            <DesktopLink onClick={() => scrollTo("tema")}>Tema</DesktopLink>
            <DesktopLink onClick={() => scrollTo("regulamento")}>
              Regulamento
            </DesktopLink>
            <DesktopLink onClick={() => scrollTo("premio")}>Prêmio</DesktopLink>
            <DesktopLink onClick={() => scrollTo("jurados")}>
              Jurados
            </DesktopLink>
            <DesktopLink onClick={() => scrollTo("etapas")}>Etapas</DesktopLink>
          </Flex>
        </Flex>
      </Container>
      {showMenuMobile()}
    </Box>
  );
};
export default Header;
